import type { SolrParams } from '#shared/solr'
import { SolrParamsKey } from '#shared/solr'
import { parse } from 'valibot'
import { solrPageResponseSchema } from '~/utils/solr/docs-response'
import { excludedNodeTypePrefixes } from '~/utils/solr/literature'

type Params = Pick<SolrParams, 'pages' | 'pageNumberString'> & {
  id?: string
  sort?: 'pageCounter asc' | 'pageCounter desc'
  rows?: number
}

export function pagesQueryKey(bookId: MaybeRefOrGetter<string>, params?: MaybeRefOrGetter<Params>) {
  return ['solr', 'pages', toValue(bookId), params] as const
}

export function pageQueryOptions(bookId: MaybeRefOrGetter<string>, params: MaybeRefOrGetter<Params>) {
  // Forwards cookies during SSR so licensed endpoints don't 401
  const fetch = useRequestFetch()

  // eslint-disable-next-line @tanstack/query/exhaustive-deps -- fetch is useRequestFetch() (stable per-render), not a real dep
  return queryOptions({
    enabled: computed(() => {
      const p = toValue(params)
      return !!p.pages || !!p.pageNumberString || !!p.id
    }),
    queryKey: pagesQueryKey(bookId, params),
    async queryFn({ signal, queryKey: [, , bookId, params] }) {
      const res = await fetch('/api/solr/literature', {
        params: {
          [SolrParamsKey.ContentType]: ['book_page'],
          [SolrParamsKey.NotSecondLevelContentType]: excludedNodeTypePrefixes,
          [SolrParamsKey.Id]: `${toValue(bookId)}*`,
          ...toValue(params),
        },
        signal,
      })

      return parse(solrPageResponseSchema, res)
    },
  })
}
